import type { TStores } from "./types/store";

export const STORES: TStores = [
    {
        store_id: "653daa33-a80d-11e7-b8d2-00155d004705", // GUID
        store_code: "Arbat",
        name: "Магазин на Арбате",
        address: "Мск, Новый Арбат, 15",
        active: true
    }, 
    {
        store_id: "9c4ba6a7-dcd2-11ec-9b97-00155d1fff01", 
        store_code: "Liteyniy",
        name: "Магазин на Литейном",
        address: "Спб, Литейный пр-т, 59",
        active: true
    }
];